import { Utilities } from "src/app/common";

export class TicketReply {
  id = null;
  ticket_id = null;
  user_id = null;
  description = null;
  original_file_name = null;
  modified_file_name = null;
  files=null;

  static init(ticketDto):TicketReply {
    if(ticketDto.files && !Array.isArray(ticketDto.files)) {
      ticketDto.files=JSON.parse(ticketDto.files);
    }

    return Object.assign({},ticketDto);
  }

  static prepare(ticket:TicketReply):TicketReply {
    var newItem = Object.assign({}, ticket);

    if(Array.isArray(newItem.files)) {
      newItem.files=JSON.stringify(newItem.files);
    }

    return Utilities.getFormatedObject(newItem);
  }
}
